import type { BonusAnnouncementEmailDraft, BonusPack } from '../types/domain';

export function defaultBonusAnnouncementEmail(
  bonus: Pick<BonusPack, 'name' | 'kind' | 'creditGrant'>
): BonusAnnouncementEmailDraft {
  if (bonus.kind === 'credit-pack') {
    const amount = bonus.creditGrant?.amount ?? 0;
    const label = bonus.creditGrant?.kind === 'publisher' ? 'Publisher' : 'generation';
    return {
      subject: `Claim your ${amount.toLocaleString('en-US')} ${label} credit bonus`,
      heading: 'A credit bonus is ready to claim',
      message: 'A permanent credit bonus is waiting for you in your Lyrixsa AI Bonus section.',
    };
  }
  return {
    subject: bonus.name.trim()
      ? `New Lyrixsa AI bonus: ${bonus.name.trim()}`
      : 'A new Lyrixsa AI bonus is available',
    heading: bonus.name.trim() || 'A new bonus is available',
    message:
      'A new bonus has been released to your Lyrixsa AI account. Sign in to view and claim it.',
  };
}
